import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const topUpStyle = () => ({
	container: {
		width: '100%',
		margin: '0px',
	},
	headingWrapper: {
		padding: '24px 32px 32px 24px',
	},
	tabsButtons: {
		display: 'flex',
		flexDirection: 'row-reverse',
		marginTop: 24,
		'& > :first-child': {
			margin: '0 0 0 8px',
		},
	},
	tabsButtonsIn: {
		backgroundColor: whiteColor,
		marginTop: 0,
		paddingRight: '32px',
		paddingBottom: '32px',
		width: '60%',
		margin: '0 auto',
		borderBottomLeftRadius: '8px',
		borderBottomRightRadius: '8px',
	},
	right: {
		textAlign: 'right',
	},
	nextButton: {
		width: 120,
	},
	confirmPaymentButton: {
		width: 168,
	},
	donationTabButtons: {
		width: '100%',
	},
});

export default topUpStyle;
